import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import Button from '../../../common/Button';
import Dialog from '../../../common/Dialog';
import TextEditor from '../../../common/TextEditor';

interface JobDescriptionPopupProps {
  open: boolean;
  onClose: () => void;
  onSave?: (jobDescription: string) => void;
  title?: string;
  subtitle?: string;
  initialJobDescription?: string;
  type?: 'add' | 'edit' | 'view';
  error?: string;
}

const JobDescriptionPopup: React.FC<JobDescriptionPopupProps> = ({
  open,
  onClose,
  onSave,
  title = 'Senior Software Engineer',
  subtitle = 'Job Description',
  initialJobDescription = '',
  type = 'edit',
  error = "",
}) => {
  const [jobDescription, setJobDescription] = useState(initialJobDescription);

  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ p: 0, background: '#FAF8FF', borderRadius: '8px' }}>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: '32px 32px 0 32px',
          }}
        >
          <svg
            width="51"
            height="51"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_523_14751)">
              <path
                d="M51 25.5C51 32.6348 48.0696 39.0849 43.3471 43.7129C43.3176 43.7418 43.2876 43.7707 43.2576 43.7996C42.8702 44.1753 42.4711 44.5394 42.0598 44.8907C41.2493 45.5849 40.3945 46.2281 39.5007 46.8161C35.4819 49.4614 30.6705 51 25.5 51C20.3295 51 15.5181 49.4614 11.4993 46.8161C10.6055 46.2281 9.75065 45.5849 8.94023 44.8907C8.5289 44.5394 8.12981 44.1753 7.74238 43.7996C7.71237 43.7707 7.68235 43.7418 7.65289 43.7129C2.93042 39.0843 0 32.6348 0 25.5C0 11.4165 11.4165 0 25.5 0C39.5835 0 51 11.4165 51 25.5Z"
                fill="#C9D1F9"
              />
              <path
                d="M33 19H30V18C30 17.4696 29.7893 16.9609 29.4142 16.5858C29.0391 16.2107 28.5304 16 28 16H24C23.4696 16 22.9609 16.2107 22.5858 16.5858C22.2107 16.9609 22 17.4696 22 18V19H19C18.2044 19 17.4413 19.3161 16.8787 19.8787C16.3161 20.4413 16 21.2044 16 22V31C16 31.7956 16.3161 32.5587 16.8787 33.1213C17.4413 33.6839 18.2044 34 19 34H33C33.7956 34 34.5587 33.6839 35.1213 33.1213C35.6839 32.5587 36 31.7956 36 31V22C36 21.2044 35.6839 20.4413 35.1213 19.8787C34.5587 19.3161 33.7956 19 33 19ZM24 18H28V19H24V18ZM34 31C34 31.2652 33.8946 31.5196 33.7071 31.7071C33.5196 31.8946 33.2652 32 33 32H19C18.7348 32 18.4804 31.8946 18.2929 31.7071C18.1054 31.5196 18 31.2652 18 31V25.39L22.68 27C22.7862 27.0144 22.8938 27.0144 23 27H29C29.1084 26.998 29.2161 26.9812 29.32 26.95L34 25.39V31ZM34 23.28L28.84 25H23.16L18 23.28V22C18 21.7348 18.1054 21.4804 18.2929 21.2929C18.4804 21.1054 18.7348 21 19 21H33C33.2652 21 33.5196 21.1054 33.7071 21.2929C33.8946 21.4804 34 21.7348 34 22V23.28Z"
                fill="#702DFF"
              />
            </g>
            <defs>
              <clipPath id="clip0_523_14751">
                <rect width="51" height="51" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <Box>
            <Typography
              sx={{ fontWeight: 700, fontSize: '24px', fontFamily: 'Inter' }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                color: '#0000008C',
                fontWeight: 500,
                fontSize: 19,
                fontFamily: 'Inter',
              }}
            >
              {subtitle}*
            </Typography>
          </Box>
        </Box>
        {/* Content */}
        <Box sx={{ mx: '32px', mt: '24px' }}>
          <TextEditor
            value={jobDescription}
            editable={type !== 'view'}
            onChange={(value) => setJobDescription(value)}
          />
          {error && (
            <Typography sx={{ color: "#E90000", fontSize: "0.75rem", mt: 1 }}>
              {error}
            </Typography>
          )}
        </Box>
        {/* Actions */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, py: 4 }}>
          <Button variant="outlined" width="120px" onClick={onClose}>
            Close
          </Button>
          {type !== 'view' && (
            <Button variant="contained" width="120px" onClick={() => onSave?.(jobDescription)}>
              Save
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default JobDescriptionPopup;
